export const LOCK_GOS_CERTIFICATES = 'LOCK_GOS_CERTIFICATES';
export const SELECT_REPORT_ROWS = 'SELECT_REPORT_ROWS';
